import { render } from "./JournalSubscribe.vue?vue&type=template&id=4ac21078&scoped=true"
import script from "./JournalSubscribe.vue?vue&type=script&lang=js"
export * from "./JournalSubscribe.vue?vue&type=script&lang=js"

import "./JournalSubscribe.vue?vue&type=style&index=0&id=4ac21078&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac21078"]])

export default __exports__